import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import { CartContext } from "../CartContext";
import Success from "../Components/Success";
import ReactPixel from "react-facebook-pixel";
import { getData } from "../Api";

const options = {
  autoConfig: true,
  debug: false,
};
ReactPixel.init("419304844367207", options);
ReactPixel.pageView();

function AllProducts() {
  const [products, setProducts] = useState([]);
  const { addToCart } = useContext(CartContext);
  const [addedToCart, setAddedToCart] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getData("/products");
        if (response.success) {
          setProducts(response.data || []);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
      }
    };

    fetchProducts();
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
    setAddedToCart((prev) => ({ ...prev, [item.id]: true }));
    setToastMessage(`${item.title} added to cart successfully!`);
    setShowToast(true);

    ReactPixel.track("AddToCart", {
      content_ids: [item.id],
      content_type: "product",
      content_name: item.title,
      currency: "INR",
      value: item.discount_price,
    });
  };

  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <section className="px-sm-5 py-5">
          <div className="row">
            {products.length > 0 ? (
              products.map((item) => (
                <div key={item.id} className="col-xl-3 col-lg-4 col-6 mb-3">
                  <div className="product-card">
                    <Link to={`/product/${item.slug}`} className="linktext">
                      <div>
                        <img
                          src={`${item.image}`}
                          className="product-image"
                          alt={item.title}
                        />
                      </div>
                      <h5 className="product-title">{item.title}</h5>
                      <p className="product-price">
                        {item.discount_price ? (
                          <>
                            <span className="text-dark discount-price me-2">
                              ₹{item.discount_price}
                            </span>
                            {/* <span className="original-price">
                              ₹{item.price}
                            </span> */}
                          </>
                        ) : (
                          <span className="discount-price">₹{item.price}</span>
                        )}
                      </p>
                    </Link>
                    <button
                      className="btn btn-cart"
                      onClick={() => handleAddToCart(item)}
                    >
                      {addedToCart[item.id] ? (
                        <>
                          <FaCheck size={16} className="me-1" /> Added
                        </>
                      ) : (
                        "Add To Cart"
                      )}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center w-100">No products available</p>
            )}
          </div>
        </section>
        <Footer />
      </main>

      {/* ✅ Toast Notification */}
      <Success
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
    </>
  );
}

export default AllProducts;
